
import { useEtapas } from '@/hooks/useEtapasData';

interface UseEtapasKanbanOptions {
  enabled?: boolean;
}

/**
 * Hook específico para buscar etapas do Kanban
 * 
 * Este hook é um wrapper do useEtapas para manter
 * compatibilidade com o código existente do Kanban
 */
export const useEtapasKanban = (options: UseEtapasKanbanOptions = {}) => {
  const { data: etapas, isLoading, error, refetch } = useEtapas(undefined, options);
  
  return {
    data: etapas || [],
    isLoading,
    error,
    refetch
  };
};
